import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '@podium-design-system/react-components/pds-mantine-styles.css';
import './argus-typography.css';
import { PodiumProvider } from '@podium-design-system/react-components';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import ApiQuotaApproachingAlerts from './components/ApiQuotaApproachingAlerts';
import Home from './pages/Dashboard';
import Cases from './pages/Cases';
import CaseDetails from './pages/CaseDetails';
import ApiLimits from './pages/ApiLimits';
import './App.css';

function App() {
  return (
    <PodiumProvider>
      <AuthProvider>
        <Router>
          <ProtectedRoute>
            <div className="App argus-app">
              <Header />
              <ApiQuotaApproachingAlerts />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/cases" element={<Cases />} />
                  <Route path="/cases/:caseId" element={<CaseDetails />} />
                  <Route path="/api-limits" element={<ApiLimits />} />
                  {/* Network graph temporarily disabled */}
                </Routes>
              </main>
            </div>
          </ProtectedRoute>
        </Router>
      </AuthProvider>
    </PodiumProvider>
  );
}

export default App;
